












































import { Component, Vue } from 'vue-property-decorator'
interface TypeListObject {
  label: string
  value: string
}

@Component({
  name: 'search'
})

export default class extends Vue {
    private form = {
      keyword: '', // 关键字
      select: '1'
    }
    private typeList:TypeListObject[] =
    [{
      label: '姓名',
      value: '1'
    }, {
      label: '班级',
      value: '2'
    }, {
      label: '科室',
      value: '3'
    }, {
      label: '类目',
      value: '4'
    }, {
      label: '类型4',
      value: '5'
    }]
    private tagList:TypeListObject[] = []
    private async onSearchClick() {
      let that = this
      let keyword = that.form.keyword
      let isUpdata = await that.typeList.find((val) => {
        if (that.form.select === val.value && that.form.keyword !== '') {
          let isAdd = that.tagList.find(item => {
            if (item.value === that.form.select) {
              that.$message('同一种类型只能有一个筛选条件')
              return item.value
            }
          })
          if (isAdd === undefined) {
            that.tagList.push({
              label: val.label + ':' + keyword,
              value: that.form.select
            })
          }
          return isAdd
        }
      })
      that.form.keyword = ''
      if (isUpdata === undefined) {
        this.$emit('getList')
      }
    }
    private handleClose(tag:TypeListObject) {
      this.tagList.splice(this.tagList.indexOf(tag), 1)
      this.$emit('getList')
    }
}

